import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-switcher-language',
  standalone: true,
  imports: [TranslateModule, CommonModule],
  templateUrl: './switcher-language.component.html',
  styleUrl: './switcher-language.component.scss',
})
export class SwitcherLanguageComponent {
  selectedLanguage = '';
  protected readonly locales = ['en', 'ar'];
  Language = 'Language';
  constructor(
    public translate: TranslateService,
  ) {
    const savedLanguage =
      this.translate.currentLang ||
      document.defaultView?.localStorage?.getItem('language') ||
      'ar';
    if (savedLanguage) {
      this.translate.use(savedLanguage);
      this.selectedLanguage = savedLanguage;
      if (savedLanguage === 'ar') {
        this.Language = 'English';
      } else {
        this.Language = 'العربية';
      }
    }
  }

  toggleLanguage(): void {
    const selectedLanguage = this.selectedLanguage === 'en' ? 'ar' : 'en';
    this.changeLanguage(selectedLanguage);
  }

  changeLanguage(language: string) {
    const localStorage = document.defaultView?.localStorage;
    this.translate.use(language);
    if (localStorage) {
      localStorage.setItem('language', language);
    }
    const Language = language;
    this.selectedLanguage = Language;
    this.selectedLanguage =
      this.selectedLanguage[0].toUpperCase() + this.selectedLanguage.slice(1);
    window.location.reload();
    // this.userService.getUserdetails().subscribe({
    //   next: res => {
    //     this.authService.refreshLoginData(res.data);
    //     window.location.reload();
    //   },
    // });
  }
}
